import { UseChatHelpers } from '@ai-sdk/react';
import { PropsWithChildren } from 'react';

import { getConversationMessageSubmit } from '../../ConversationContextProvider/ConversationContextProvider.hook';
import { UIChatMessage } from '../chat.types';

import { MessageSubmissionContext } from './MessageSubmissionContextProvider.hook';

interface MessageSubmissionContextProviderProps {
  sendMessage: UseChatHelpers<UIChatMessage>['sendMessage'];
}

export const MessageSubmissionContextProvider = ({
  sendMessage,
  children,
}: PropsWithChildren<MessageSubmissionContextProviderProps>) => {
  const submitMessage = getConversationMessageSubmit({ sendMessage });
  return <MessageSubmissionContext.Provider value={{ submitMessage }}>{children}</MessageSubmissionContext.Provider>;
};
